import { NavLink } from "react-router-dom";
import { X, Music } from "lucide-react";
import gggLogo from "@/assets/logos/ggg-logo-final.webp";

// Full-screen mobile navigation panel. Always mounted (visibility is
// toggled via the `mobile-menu-open` CSS class) so closing plays a smooth
// opacity fade instead of an abrupt unmount. Receives a ref for its outer
// container (used by the focus-trap hook in the parent Navbar) and a ref
// for the first focusable link (initial focus target on open).
const MobileMenu = ({ navLinks, open, menuRef, firstLinkRef, onClose, onMusicToggle, musicPlaying }) => (
  <div
    className={`mobile-menu ${open ? "mobile-menu-open" : ""}`}
    ref={menuRef}
    role="dialog"
    aria-modal="true"
    aria-label="Site navigation"
    aria-hidden={!open}
  >
    <div className="page-shell mobile-menu-header flex items-center justify-between shrink-0">
      <img src={gggLogo} alt="Gopi Gadhvi Group" className="mobile-menu-logo" />
      <button
        onClick={onClose}
        data-testid="nav-mobile-close"
        className="hamburger-btn flex items-center justify-center"
        aria-label="Close navigation menu"
        tabIndex={open ? 0 : -1}
      >
        <X size={26} />
      </button>
    </div>
    <nav className="flex-1 flex flex-col items-center justify-center gap-6 px-6" aria-label="Mobile primary">
      {navLinks.map((link, idx) => (
        <NavLink
          key={link.to}
          ref={idx === 0 ? firstLinkRef : undefined}
          to={link.to}
          end={link.to === "/"}
          tabIndex={open ? 0 : -1}
          data-testid={`nav-mobile-link-${link.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
          className={({ isActive }) => `text-h3 py-1 ${isActive ? "" : "opacity-80"}`}
          style={({ isActive }) => ({ color: isActive ? "var(--gg-logo-gold)" : undefined })}
        >
          {link.label}
        </NavLink>
      ))}
      <button
        type="button"
        onClick={onMusicToggle}
        data-testid="nav-mobile-music-toggle"
        aria-label={musicPlaying ? "Pause ambient music" : "Play ambient music"}
        aria-pressed={musicPlaying}
        tabIndex={open ? 0 : -1}
        className="btn-nav-cta gap-2 mt-4"
      >
        <Music size={16} /> Music
      </button>
    </nav>
  </div>
);

export default MobileMenu;
